<template>
  <div :class="classes">
    <img v-if="person === 'woman'" data-src="./assets/parachuter-woman-mid.png">
    <img v-if="person === 'man'" data-src="./assets/parachuter-man-mid.png">
  </div>
</template>

<script>
export default{
  name: 'parachuter',
  data() {
    return {
      playing: false
    }
  },
  props: {
    direction: { type: String, default: 'right' },
    person: { type: String, default: 'man' },
    delayed: { type: Boolean, default: false }
  },
  computed: {
    classes() {
      return {
        parachuter: true,
        playing: this.playing,
        man: this.person === 'man',
        woman: this.person === 'woman',
        right: this.direction === 'right',
        left: this.direction === 'left',
        delayed: this.delayed
      }
    }
  },
  methods: {
    play() {
      this.playing = true
    },
    pause() {
      this.playing = false
    }
  }
}
</script>

<style scoped lang="scss">
/** parachuter **/
@import '../theme';

$parachuter-w: 90px;

// How far the sway animation rotates.
$r: 2deg;
// How far the sway animation skews.
$s: -5deg;
// How far the sway animation translates horizontally.
$x: -5px;

// How long it takes to sway back and forth.
$sway-duration: 3s;
// How long it takes to traverse the page.
$travel-duration: 150s;
// The delay before a parachuter comes into view.
$travel-delay: $travel-duration * 0.2;

@keyframes sway-right {
  0% {
    transform: translateX(0) skew(0) rotate(0);
  }
  50% {
    transform: translateX(#{$x}) skew(#{$s}) rotate(#{$r});
  }
  100% {
    transform: translateX(0) skew(0) rotate(0);
  }
}

@keyframes travel-right {
  from {
    top: 35%;
    left: $parachuter-w * -1;
  }
  to {
    top:  calc(100% + #{$parachuter-w});
    left: calc(100% + #{$parachuter-w});
  }
}

@keyframes sway-left {
  0% {
    transform: scaleX(-1) skew(0) translateX(0);
  }
  50% {
    transform: scaleX(-1) skew(#{$s * -1}) translateX(#{$x * -1});
  }
  100% {
    transform: scaleX(-1) skew(0) translateX(0);
  }
}

@keyframes travel-left {
  from {
    top: 35%;
    right: $parachuter-w * -1;
  }
  to {
    top:   calc(100% + #{$parachuter-w});
    right: calc(100% + #{$parachuter-w});
  }
}

@function travel($direction, $sway-delay: 0s) {
  // If we pass a sway delay, then also slow the sway duration
  // so that when we have multiple parachuters on a page
  // they look like they are swaying independently.
  $sway-speed: $sway-duration;
  @if $sway-delay == 0s {
    $sway-speed: $sway-duration * 1.2;
  }

  @return
    sway-#{$direction} $sway-speed ease-in-out $sway-delay infinite paused,
    travel-#{$direction} $travel-duration linear infinite paused;
}

.parachuter {
  position: absolute;
  top: -500px;
  left: -500px;
  z-index: zespri-layer(parachuter);
  transform-origin: top center;
  max-width: $parachuter-w;

  &.delayed {
    animation-delay: $travel-delay !important;
  }

  &.man {
    animation: travel(right);

    &.left {
      animation: travel(left);
    }
  }

  &.woman {
    animation: travel(right, 0.5s);

    &.left {
      animation: travel(left);
    }
  }

  &.playing {
    animation-play-state: running !important;
  }
}
</style>
